const cost = (amount: number) => 25 + 0.01 * amount;

export const PayService = {
    cost,
};
